var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGdnx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GDNX_svg__a",
    x1: 512,
    y1: 252.5,
    x2: 512,
    y2: 883.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c23b1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GDNX_svg__b",
    x1: 401.98,
    y1: 138.21,
    x2: 260.96,
    y2: 279.24,
    xlinkHref: "#GDNX_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GDNX_svg__c",
    x1: 605.03,
    y1: 177.07,
    x2: 749.81,
    y2: 321.86,
    xlinkHref: "#GDNX_svg__a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1005.11 431.86l-407.29 407.3a121.38 121.38 0 01-171.64 0L18.89 431.86a64.43 64.43 0 010-91.16l132.94-132.94 30.48-30.49a43.09 43.09 0 000 61L512 567.93l329.69-329.69a43.09 43.09 0 000-61l30.48 30.49 132.94 132.97a64.43 64.43 0 010 91.16z",
    fill: "url(#GDNX_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M493.21 227.59L332.44 388.37 182.31 238.24a43.09 43.09 0 010-61l.52-.52a93.76 93.76 0 0166.29-27.46h165.79z",
    fill: "url(#GDNX_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M841.69 238.24L689.48 390.45l-104.4-104.39H477.55l136.24-136.24H775.4a93.73 93.73 0 0166.29 27.45 43.09 43.09 0 010 60.97z",
    fill: "url(#GDNX_svg__c)"
  })));
}
export default SvgGdnx;